import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useNavigate } from "react-router-dom";
import BetSlipContext from "../../context/BetSlipContext";
import SkyLayout from "./SkyLayout";
import { isEmpty, startCase } from "lodash";
import SelectionFav from "./SelectionFav";
import { useFavoritesLogic } from "../useLogic/useFavoritesLogic";
const FavouriteSky = () => {
  const setLimit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLimit;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const defaultStakeLimit = useContextSelector(AuthContext, (ctx) => {
    return ctx.defaultStakeLimit;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const {
    list,
    position,
    loader,
    odds,
    oddsHistory,
    active,
    handleActive,
    addToFavourite,
  } = useFavoritesLogic();
  const navigate = useNavigate();
  return (
    <SkyLayout>
      <div id="multiMarketsWrap" className="mian-wrap">
        {list?.length > 0 ? (
          list?.map((res) => {
            let matchOdds =
              odds[res?.eventId]?.find((item) => {
                return item?.type == "odds";
              })?.data || {};
            let matchOddsOld =
              odds[res?.eventId]?.find((item) => {
                return item?.type == "odds";
              })?.data || {};

            let matchSportBook =
              odds[res?.eventId]
                ?.find((item) => {
                  return item?.type == "sportbook";
                })
                ?.data?.filter((item) => {
                  return item?.betfairEventId == res?.eventId;
                }) || {};

            let getActive = active?.find((obj) => {
              return obj?.eventId == res?.eventId;
            });
            let updatedPosition =
              position?.length > 0
                ? position?.find((obj) => {
                    return obj?.eventId == res?.eventId;
                  }) || {}
                : {};
            return (
              res?.Odds?.length > 0 &&
              res?.Odds?.map((item) => {
                let oddsInner =
                  matchOdds?.length > 0
                    ? matchOdds?.find((obj) => {
                        return obj?.mi == item?.marketId;
                      })
                    : {};
                let OldoddsInner =
                  matchOddsOld?.length > 0
                    ? matchOddsOld?.find((obj) => {
                        return obj?.mi == item?.marketId;
                      })
                    : {};
                let backOdds =
                  !isEmpty(oddsInner) && oddsInner?.rt?.length > 0
                    ? oddsInner?.rt?.filter((rt) => rt.ib)
                    : [];

                let layOdds =
                  !isEmpty(oddsInner) && oddsInner?.rt?.length > 0
                    ? oddsInner?.rt?.filter((rt) => !rt.ib)
                    : [];
                let OldbackOdds =
                  !isEmpty(OldoddsInner) && OldoddsInner?.rt?.length > 0
                    ? OldoddsInner?.rt?.filter((rt) => rt.ib)
                    : [];

                let OldlayOdds =
                  !isEmpty(OldoddsInner) && OldoddsInner?.rt?.length > 0
                    ? OldoddsInner?.rt?.filter((rt) => !rt.ib)
                    : [];
                let ms = !isEmpty(oddsInner)
                  ? oddsInner?.ms
                  : item?.totalMatched;
                let totalMatched = !isEmpty(oddsInner)
                  ? oddsInner?.totalMatched
                  : 0;

                return (
                  <div
                    id="multiMarket_34737089_1_247827387"
                    style={{ display: "block" }}
                  >
                    <div
                      onClick={() =>
                        navigate(
                          `/match-detail-sky/${res?.eventId}/${res?.marketId}`
                        )
                      }
                      className="game-wrap multi"
                    >
                      <h4 id="gameInfo" className="game-info">
                        {startCase(res?.gameType)}
                        <ul id="infoIcon" className="info-icon">
                          {res?.status == "in_play" && (
                            <li id="inPlayIcon">
                              <img
                                className="info-inplay"
                                src="/assets/images/transparent.gif"
                              />
                              In-Play
                            </li>
                          )}
                        </ul>
                      </h4>
                      <table id="gameTeam" className="game-team">
                        <tbody>
                          <tr>
                            <th>
                              <a
                                id="multiMarketPin"
                                className="pin-on"
                                href="#"
                                title="Remove from Multi Markets"
                              />
                              <h4 id="eventName">Zimbabwe v Namibia</h4>
                            </th>
                            <td className="team-multi_Go">
                              <a
                                id="goToFullMarket"
                                className="multi-Go"
                                href='javascript:MobileMenuHandler.loadPage("fullMarket.jsp?eventType=4&eventId=34737089&marketId=1.247827387",true)'
                              />
                            </td>
                            <td className="team-refresh">
                              <a id="refresh" className="refresh" href="#" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <SelectionFav
                      active={getActive?.Odds}
                      addToFavioute={addToFavourite}
                      handleActive={handleActive}
                      totalMatched={totalMatched}
                      ms={ms}
                      layOdds={layOdds}
                      backOdds={backOdds}
                      oldBack={OldbackOdds}
                      oldLay={OldlayOdds}
                      OuterObject={res}
                      object={item}
                      betSlipObject={betSlipObject}
                      showBetDialog={showBetDialog}
                      user={user}
                      setShowBetDialog={setShowBetDialog}
                      setBetSlipObject={setBetSlipObject}
                      setToastObject={setToastObject}
                      defaultStakeLimit={defaultStakeLimit}
                      setLimit={setLimit}
                      position={updatedPosition?.betFair || []}
                      profileData={
                        item?.matchSetting?.length > 0
                          ? {
                              ...item,
                              arrayCheck: "details",
                              profile: profileData,
                            }
                          : {
                              ...profileData,
                              arrayCheck: "profile",
                              profile: profileData,
                            }
                      }
                    />
                  </div>
                );
              })
            );
          })
        ) : (
          <div id="noMultiMarkets" className="no-data">
            <h3>There are currently no followed multi markets.</h3>
            <p>Please add some markets from events.</p>
          </div>
        )}
      </div>
    </SkyLayout>
  );
};

export default FavouriteSky;
